import Swiper from "swiper";
import {Navigation} from "swiper/modules";

function renderStars(container) {
    const raw = container.dataset.score;
    if (!raw) return;
    const score = parseFloat(raw.replace(',', '.'));
    const total = 5;
    let html = '';
    for (let i = 1; i <= total; i++) {
        if (score >= i) {
            html += '<i class="icon icon-star-filled"></i>';
        } else if (score >= i - 0.5) {
            html += '<i class="icon icon-star-half"></i>';
        } else {
            html += '<i class="icon icon-star"></i>';
        }
    }
    container.innerHTML = html;
}

export function initKununuSlider() {
    for (const el of document.querySelectorAll('.kununuSlider__stars')) {
        renderStars(el);
    }

    for (const slider of document.querySelectorAll('.kununuSlider__slider')) {
        new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            }
        });
    }
}
